import React, { useState } from 'react';
import { Star, MapPin, Phone, Calendar, ArrowRight, Award, Users, Clock, Stethoscope, GraduationCap, Shield, CheckCircle, Building2, Globe , ChevronLeft, ChevronRight} from 'lucide-react';
import ArtemisHospital from "../Images/home/artemis-hospital.jpg";
import Asian3 from "../Images/home/asian3.jpg";
import FortisHospitalBangalore from "../Images/home/fortis_hospital_bangalore.jpeg";
import MetroF1 from "../Images/home/metro-f-1.jpg";
import Motherland1 from "../Images/home/motherland1.png";
import Sahaydri from "../Images/home/sahaydri.jpg";
import FortisEscortsHospitalNewDelhi from "../Images/home/Fortis-Escorts-Hospital-New-Delhi.jpg";
import FortisLa from "../Images/home/fortis-la.jpg";
import doctor1 from "../Images/home/dr-ashok2.jpg";
import doctor2 from "../Images/home/dr.lalit.jpg";
import doctor3 from "../Images/home/dr-subrat.jpg";
import doctor4 from "../Images/home/dr.sachin.jpeg";
import doctor5 from "../Images/home/dr-vivek-jawali.jpg";
import doctor6 from "../Images/home/dr-vijaay.jpg";
import doctor7 from "../Images/home/aditya.jpg";
import doctor8 from "../Images/home/Dr.-Parimala-Devi.png";
import doctor9 from "../Images/home/dr-(col)-manjinder-sandh.png";
import doctor10 from "../Images/home/Dr-Mohan-Keshavamurth.jpg";
import img7 from "../Images/home/hipreplacement.png";
import img8 from "../Images/home/orthopedics.png";
import img9 from "../Images/home/liver1.png";
import img10 from "../Images/home/urology.png";
import img11 from "../Images/home/ivf (1).png";
import img12 from "../Images/home/bone.png"; 
import Contactwebform from "./Webform";
const HospitalTreatmentsShowcase = () => {
    const [showContactModal, setShowContactModal] = useState(false);
 const topHospitals = [
  {
    id: 1,
    name: "Artemis Hospitals",
    location: "Gurugram, India",
    rating: 4.7,
    reviews: 1745,
    specialties: ["Cardiology", "Oncology", "Nephrology"],
    image: ArtemisHospital,
    beds: "550+",
    accreditation: "JCI & NABH Accredited",
    established: "2007"
  },
  {
    id: 2,
    name: "Asian Institute of Medical Sciences",
    location: "Faridabad, India",
    rating: 4.6,
    reviews: 1389,
    specialties: ["Orthopedics", "Urology", "General Surgery"],
    image: Asian3,
    beds: "425+",
    accreditation: "NABH Accredited",
    established: "2010"
  },
  {
    id: 3,
    name: "Fortis Hospital Bannerghatta Road",
    location: "Bangalore, India",
    rating: 4.8,
    reviews: 1920,
    specialties: ["Oncology", "Neurosciences", "Gastroenterology"],
    image: FortisHospitalBangalore,
    beds: "400+",
    accreditation: "JCI Accredited",
    established: "2006"
  },
  {
    id: 4,
    name: "Metro Hospital Faridabad",
    location: "Faridabad, India",
    rating: 4.5,
    reviews: 1104,
    specialties: ["Cardiology", "Internal Medicine", "ENT"],
    image: MetroF1,
    beds: "300+",
    accreditation: "NABH Accredited",
    established: "2002"
  },
  {
    id: 5,
    name: "Motherland Hospital",
    location: "Noida, India",
    rating: 4.6,
    reviews: 890,
    specialties: ["Obstetrics", "Gynecology", "Pediatrics"],
    image: Motherland1,
    beds: "150+",
    accreditation: "NABH Accredited",
    established: "2015"
  },
  {
    id: 6,
    name: "Sahyadri Hospitals",
    location: "Pune, India",
    rating: 4.7,
    reviews: 1578,
    specialties: ["Nephrology", "Neurology", "Critical Care"],
    image: Sahaydri,
    beds: "900+",
    accreditation: "NABH Accredited",
    established: "1994"
  },
  {
    id: 7,
    name: "Fortis Escorts Heart Institute",
    location: "New Delhi, India",
    rating: 4.9,
    reviews: 2893,
    specialties: ["Cardiology", "Cardiothoracic Surgery", "Emergency Care"],
    image: FortisEscortsHospitalNewDelhi,
    beds: "310+",
    accreditation: "JCI Accredited",
    established: "1988"
  },
  {
    id: 8,
    name: "Fortis La Femme",
    location: "New Delhi, India",
    rating: 4.8,
    reviews: 1456,
    specialties: ["Women's Health", "Neonatology", "Fertility"],
    image: FortisLa,
    beds: "260+",
    accreditation: "NABH Accredited",
    established: "2004"
  }
];

 const topDoctors = [
  {
    id: 1,
    name: "Dr. Ashok Seth",
    specialty: "Chairman, Fortis Escorts Heart Institute",
    experience: "38+ Years",
    rating: 4.9,
    reviews: 3200,
    image: doctor1,
    hospital: "Fortis Escorts Heart Institute, New Delhi",
    qualification: "MBBS, MD, DM (Cardiology), FRCP, FACC, FESC",
     
    availability: "Mon-Sat",
    languages: ["English", "Hindi"]
  },
  {
    id: 2,
    name: "Dr. Lalit Kumar",
    specialty: "Director, Medical Oncology",
    experience: "35+ Years",
    rating: 4.8,
    reviews: 2800,
    image: doctor2,
    hospital: "Rajiv Gandhi Cancer Institute, Delhi",
    qualification: "MBBS, MD, DM (Oncology)",
    
    availability: "Mon-Fri",
    languages: ["English", "Hindi"]
  },
  {
    id: 3,
    name: "Dr. Subrat Kumar Acharya",
    specialty: "Senior Consultant, Neurosurgery",
    experience: "25+ Years",
    rating: 4.7,
    reviews: 2100,
    image: doctor3,
    hospital: "Fortis Hospital, Noida",
    qualification: "MBBS, MS, MCh (Neurosurgery)",
   
    availability: "Mon-Sat",
    languages: ["English", "Hindi"]
  },
  {
    id: 4,
    name: "Dr. Sachin Wani",
    specialty: "Director, Gastroenterology",
    experience: "20+ Years",
    rating: 4.8,
    reviews: 1800,
    image: doctor4,
    hospital: "Fortis Hospital, Mulund, Mumbai",
    qualification: "MBBS, MD, DM (Gastroenterology)",
    
    availability: "Mon-Fri",
    languages: ["English", "Hindi", "Marathi"]
  },
  {
    id: 5,
    name: "Dr. Vivek Jawali",
    specialty: "Chairman, Cardiothoracic Surgery",
    experience: "40+ Years",
    rating: 4.9,
    reviews: 3500,
    image: doctor5,
    hospital: "Fortis Hospital, Bangalore",
    qualification: "MBBS, MS, MCh (Cardiothoracic Surgery)",
 
    availability: "Mon-Sat",
    languages: ["English", "Hindi", "Kannada"]
  },
  {
    id: 6,
    name: "Dr. Vijay Kher",
    specialty: "Chairman, Nephrology",
    experience: "42+ Years",
    rating: 4.8,
    reviews: 2700,
    image: doctor6,
    hospital: "Medanta - The Medicity, Gurugram",
    qualification: "MBBS, MD, DM (Nephrology)",
      
    availability: "Mon-Fri",
    languages: ["English", "Hindi"]
  },
  {
    id: 7,
    name: "Dr. Aditya Gupta",
    specialty: "Director, Neurosurgery",
    experience: "27+ Years",
    rating: 4.7,
    reviews: 2200,
    image: doctor7,
    hospital: "Artemis Hospital, Gurugram",
    qualification: "MBBS, MCh (Neurosurgery)",
     
    availability: "Mon-Sat",
    languages: ["English", "Hindi"]
  },
  {
    id: 8,
    name: "Dr. Parimala Devi",
    specialty: "Senior Consultant, Obstetrics & Gynecology",
    experience: "30+ Years",
    rating: 4.8,
    reviews: 2000,
    image: doctor8,
    hospital: "Motherhood Hospital, Bangalore",
    qualification: "MBBS, MD (Obstetrics & Gynecology)",
    
    availability: "Mon-Fri",
    languages: ["English", "Hindi", "Kannada"]
  },
  {
    id: 9,
    name: "Dr. Manjinder Sandhu",
    specialty: "Director, Cardiology",
    experience: "28+ Years",
    rating: 4.9,
    reviews: 2500,
    image: doctor9,
    hospital: "Artemis Hospital, Gurugram",
    qualification: "MBBS, MD, DM (Cardiology)",
    
    availability: "Mon-Sat",
    languages: ["English", "Hindi", "Punjabi"]
  },
  {
    id: 10,
    name: "Dr. Mohan Keshavamurthy",
    specialty: "Director, Urology, Transplant & Robotic Surgery",
    experience: "30+ Years",
    rating: 4.8,
    reviews: 2100,
    image: doctor10,
    hospital: "Fortis Hospital, Bangalore",
    qualification: "MBBS, MS, DNB (Urology)",
     
    availability: "Mon-Fri",
    languages: ["English", "Hindi", "Kannada"]
  }
];

 const topTreatments = [
  {
    id: 7,
    name: "Hip Replacement",
    description: "Advanced total hip replacement surgery using latest prosthetics ensuring pain-free mobility.",
    image: img7,
    duration: "2-3 hours",
    recovery: "6-10 weeks",
    successRate: "95%",
    hospitals: 20,
    price: "₹1,80,000 - ₹4,50,000",
    category: "Orthopedics"
  },
  {
    id: 8,
    name: "Knee Replacement",
    description: "Minimally invasive knee replacement for restoring joint function and reducing chronic pain.",
    image: img8,
    duration: "2-3 hours",
    recovery: "4-8 weeks",
    successRate: "94%",
    hospitals: 25,
    price: "₹2,00,000 - ₹5,00,000",
    category: "Orthopedics"
  },
  {
    id: 9,
    name: "Liver Transplant",
    description: "Life-saving transplant surgeries with expert pre and post-operative liver care.",
    image: img9,
    duration: "8-12 hours",
    recovery: "3-6 months",
    successRate: "89%",
    hospitals: 10,
    price: "₹18,00,000 - ₹25,00,000",
    category: "Transplant Surgery"
  },
  {
    id: 10,
    name: "Kidney Transplant",
    description: "Safe and effective kidney transplant procedures from living or deceased donors.",
    image: img10,
    duration: "4-6 hours",
    recovery: "2-3 months",
    successRate: "93%",
    hospitals: 15,
    price: "₹5,00,000 - ₹12,00,000",
    category: "Transplant Surgery"
  },
  {
    id: 11,
    name: "IVF",
    description: "State-of-the-art fertility treatment with personalized IVF plans and high success rates.",
    image: img11,
    duration: "6-8 weeks",
    recovery: "Minimal",
    successRate: "60-70%",
    hospitals: 30,
    price: "₹1,00,000 - ₹3,50,000",
    category: "Fertility"
  },
  {
    id: 12,
    name: "Bone Marrow Transplant",
    description: "Cutting-edge transplant services for leukemia, lymphoma, and other blood disorders.",
    image: img12,
    duration: "6-8 hours",
    recovery: "3-6 months",
    successRate: "75-85%",
    hospitals: 8,
    price: "₹10,00,000 - ₹25,00,000",
    category: "Oncology"
  }
];
const ContactModal = ({ isOpen, onClose, hospitalName = null }) => {
  return (
    <Contactwebform 
      isOpen={isOpen} 
      onClose={onClose}
    />
  );
};

// Main Component



  const handleBookAppointment = (e, hospitalName) => {
    e.stopPropagation(); // Prevent event bubbling
    setShowContactModal(true);
  };

  const handleSectionClick = () => {
    setShowContactModal(true);
  };



  return (
   <div className="min-h-screen bg-gray-50">
      {/* Top Hospitals Section */}
        <section 
        className="py-8 bg-gradient-to-br from-slate-900 via-teal-900 to-teal-800 cursor-pointer"
        onClick={handleSectionClick}
      >
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-full mb-3">
              <Building2 className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">Premier Healthcare Institutions</h2>
            <p className="text-sm text-slate-200 max-w-xl mx-auto">
              India's most trusted hospitals with international accreditations
            </p>
          </div>
          
          {/* Carousel Container with Navigation */}
          <div className="relative">
            {/* Left Arrow */}
            <button 
              onClick={(e) => {
                e.stopPropagation();
                const container = e.target.closest('.relative').querySelector('.flex.space-x-4');
                container.scrollBy({ left: -300, behavior: 'smooth' });
              }}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-teal-600 p-2 rounded-full shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:scale-110"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            {/* Right Arrow */}
            <button 
              onClick={(e) => {
                e.stopPropagation();
                const container = e.target.closest('.relative').querySelector('.flex.space-x-4');
                container.scrollBy({ left: 300, behavior: 'smooth' });
              }}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-teal-600 p-2 rounded-full shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:scale-110"
            >
              <ChevronRight className="w-5 h-5" />
            </button>

            <div className="flex space-x-4 overflow-x-auto pb-4 scrollbar-hide mx-8">
              {topHospitals.map((hospital) => (
                <div key={hospital.id} className="flex-none w-64 sm:w-72 bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col h-[480px]">
                  <div className="relative">
                    <img 
                      src={hospital.image} 
                      alt={hospital.name}
                      className="w-full h-32 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                    <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full shadow">
                      <div className="flex items-center space-x-1">
                        <Star className="w-3 h-3 text-amber-500 fill-current" />
                        <span className="text-xs font-bold text-gray-900">{hospital.rating}</span>
                      </div>
                    </div>
                    <div className="absolute top-2 left-2 bg-teal-600/90 backdrop-blur-sm text-white px-2 py-1 rounded-full">
                      <span className="text-xs font-semibold">{hospital.accreditation}</span>
                    </div>
                  </div>
                  
                  <div className="p-4 flex flex-col flex-1">
                    <div className="mb-3 h-20 flex flex-col justify-start">
                      <h3 className="text-lg font-bold text-gray-900 mb-1 leading-tight">{hospital.name}</h3>
                      <div className="flex items-center text-gray-600 mb-1">
                        <MapPin className="w-3 h-3 mr-1 text-teal-600 flex-shrink-0" />
                        <span className="text-xs truncate">{hospital.location}</span>
                      </div>
                      <div className="flex items-center text-gray-500">
                        <Globe className="w-3 h-3 mr-1 flex-shrink-0" />
                        <span className="text-xs">Est. {hospital.established}</span>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-2 mb-3 p-2 bg-gray-50 rounded-lg h-16">
                      <div className="text-center">
                        <div className="flex items-center justify-center mb-1">
                          <Users className="w-3 h-3 text-teal-600 mr-1" />
                          <span className="text-sm font-bold text-gray-900">{hospital.beds}</span>
                        </div>
                        <span className="text-xs text-gray-600">Beds</span>
                      </div>
                      <div className="text-center">
                        <div className="flex items-center justify-center mb-1">
                          <CheckCircle className="w-3 h-3 text-green-600 mr-1" />
                          <span className="text-sm font-bold text-gray-900">{hospital.reviews}</span>
                        </div>
                        <span className="text-xs text-gray-600">Reviews</span>
                      </div>
                    </div>
                    
                    <div className="mb-3 h-12 flex items-start">
                      <div className="flex flex-wrap gap-1">
                        {hospital.specialties.slice(0, 2).map((specialty, index) => (
                          <span key={index} className="px-2 py-1 bg-teal-50 border border-teal-200 text-teal-700 text-xs rounded-full font-medium">
                            {specialty}
                          </span>
                        ))}
                        {hospital.specialties.length > 2 && (
                          <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                            +{hospital.specialties.length - 2}
                          </span>
                        )}
                      </div>
                    </div>
                    
                    <div className="border-t pt-3 mt-auto">
                      <button 
                        onClick={(e) => handleBookAppointment(e, hospital.name)}
                        className="w-full bg-gradient-to-r from-teal-600 to-teal-700 text-white py-2 rounded-lg hover:from-teal-700 hover:to-teal-800 transition-all duration-300 flex items-center justify-center space-x-2 text-sm font-semibold h-10"
                      >
                        <span>Book Appointment</span>
                        <ArrowRight className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <ContactModal 
        isOpen={showContactModal} 
        onClose={() => setShowContactModal(false)}
      />
      
      {/* Top Doctors Section */}
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-12">
        <section
          className="py-8"
          onClick={handleSectionClick}
          style={{ cursor: "pointer" }}
        >
          <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-teal-100 to-blue-100 rounded-full mb-4 shadow-lg">
                <Stethoscope className="w-8 h-8 text-teal-600" />
              </div>

              {/* Custom Scrollbar Styles */}
              <style jsx>{`
                .scrollbar-hide {
                  -ms-overflow-style: none;
                  scrollbar-width: none;
                }
                .scrollbar-hide::-webkit-scrollbar {
                  display: none;
                }

                .custom-scrollbar::-webkit-scrollbar {
                  height: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                  background: #f1f5f9;
                  border-radius: 3px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                  background: #0d9488;
                  border-radius: 3px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                  background: #0f766e;
                }
              `}</style>

              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                Distinguished Medical Specialists
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Connect with renowned physicians who bring extensive experience and expertise in their specializations
              </p>
            </div>

            {/* Horizontal Scroll Container with Navigation */}
            <div className="relative">
              {/* Left Arrow */}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  const container = e.target.closest('.relative').querySelector('.flex.space-x-4');
                  container.scrollBy({ left: -300, behavior: 'smooth' });
                }}
                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-teal-600 p-2 rounded-full shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:scale-110"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              {/* Right Arrow */}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  const container = e.target.closest('.relative').querySelector('.flex.space-x-4');
                  container.scrollBy({ left: 300, behavior: 'smooth' });
                }}
                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-teal-600 p-2 rounded-full shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:scale-110"
              >
                <ChevronRight className="w-5 h-5" />
              </button>

              {/* <div className="text-center mb-4">
                <p className="text-sm text-gray-500">← Scroll horizontally to view all specialists →</p>
              </div> */}

              <div className="flex space-x-4 overflow-x-auto pb-4 scrollbar-hide mx-8">
                {topDoctors.map((doctor) => (
                  <div
                    key={doctor.id}
                    className="flex-none w-72 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
                  >
                    {/* Image Section */}
                    <div className="relative h-40 overflow-hidden">
                      <img
                        src={doctor.image}
                        alt={doctor.name}
                        className="w-full h-full object-cover object-center transition-transform duration-300 hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>

                      {/* Rating */}
                      <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full shadow">
                        <div className="flex items-center space-x-1">
                          <Star className="w-3 h-3 text-amber-500 fill-current" />
                          <span className="text-xs font-bold text-gray-900">{doctor.rating}</span>
                        </div>
                      </div>

                      {/* Experience */}
                      <div className="absolute bottom-2 left-2 bg-teal-600/90 backdrop-blur-sm text-white px-2 py-1 rounded-full">
                        <span className="text-xs font-semibold">{doctor.experience}</span>
                      </div>
                    </div>

                    {/* Card Content */}
                    <div className="p-4 flex flex-col flex-1">
                      {/* Doctor Info with fixed height */}
                      <div className="mb-3 h-[120px]">
                        <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-1">{doctor.name}</h3>
                        <p className="text-teal-600 font-semibold text-sm mb-1 line-clamp-1">{doctor.specialty}</p>
                        <p className="text-xs text-gray-600 mb-1 line-clamp-1">{doctor.hospital}</p>
                        <p className="text-xs text-gray-500 line-clamp-1">{doctor.qualification}</p>
                      </div>

                      {/* Availability & Language with fixed height */}
                      <div className="grid grid-cols-2 gap-2 mb-3 p-2 bg-gray-50 rounded-lg h-[72px]">
                        <div>
                          <div className="flex items-center mb-1">
                            <Clock className="w-3 h-3 text-teal-600 mr-1" />
                            <span className="text-xs font-semibold text-gray-900">Available</span>
                          </div>
                          <span className="text-xs text-gray-600 line-clamp-1">{doctor.availability}</span>
                        </div>
                        <div>
                          <div className="flex items-center mb-1">
                            <Globe className="w-3 h-3 text-teal-600 mr-1" />
                            <span className="text-xs font-semibold text-gray-900">Languages</span>
                          </div>
                          <span className="text-xs text-gray-600 line-clamp-1">
                            {doctor.languages?.slice(0, 2).join(", ")}
                          </span>
                        </div>
                      </div>

                      {/* Reviews */}
                      <div className="mb-2">
                        <span className="text-xs text-gray-600">{doctor.reviews} reviews</span>
                      </div>

                      {/* Book Button sticks to bottom */}
                      <div className="mt-auto">
                        <button className="w-full bg-gradient-to-r from-teal-600 to-teal-700 text-white py-2 rounded-lg hover:from-teal-700 hover:to-teal-800 transition-all duration-300 text-sm font-semibold">
                          Book Consultation
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Scroll Dots */}
              <div className="flex justify-center mt-4 space-x-2">
                <div className="h-2 w-2 bg-teal-600 rounded-full"></div>
                <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
                <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
                <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
                <div className="h-2 w-2 bg-gray-300 rounded-full"></div>
              </div>
            </div>

            {/* View All Button */}
            <div className="text-center mt-8">
              <button className="bg-white text-teal-600 px-6 py-2 rounded-lg font-semibold border-2 border-teal-600 hover:bg-teal-600 hover:text-white transition-all duration-300 shadow">
                View All Specialists
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Top Treatments Section */}
      <section
        className="py-8 bg-gradient-to-br from-gray-50 to-gray-100"
        onClick={handleSectionClick}
        style={{ cursor: "pointer" }}
      >
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-teal-100 rounded-full mb-3">
              <Shield className="w-6 h-6 text-teal-600" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">Advanced Medical Treatments</h2>
            <p className="text-sm text-gray-600 max-w-xl mx-auto">
              State-of-the-art procedures using cutting-edge technology
            </p>
          </div>
          
          {/* Carousel Container with Navigation */}
          <div className="relative">
            {/* Left Arrow */}
            <button 
              onClick={(e) => {
                e.stopPropagation();
                const container = e.target.closest('.relative').querySelector('.flex.space-x-4');
                container.scrollBy({ left: -300, behavior: 'smooth' });
              }}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-teal-600 p-2 rounded-full shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:scale-110"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            {/* Right Arrow */}
            <button 
              onClick={(e) => {
                e.stopPropagation();
                const container = e.target.closest('.relative').querySelector('.flex.space-x-4');
                container.scrollBy({ left: 300, behavior: 'smooth' });
              }}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-teal-600 p-2 rounded-full shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:scale-110"
            >
              <ChevronRight className="w-5 h-5" />
            </button>

            <div className="flex space-x-4 overflow-x-auto pb-4 scrollbar-hide mx-8">
              {topTreatments.map((treatment) => (
                <div key={treatment.id} className="flex-none w-64 sm:w-72 bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col h-[520px]">
                  <div className="relative bg-green-100">
                    <img 
                      src={treatment.image} 
                      alt={treatment.name}
                      className="w-full h-32 object-contain p-2"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                    <div className="absolute top-2 right-2 bg-green-500/90 backdrop-blur-sm text-white px-2 py-1 rounded-full shadow">
                      <span className="text-xs font-bold">{treatment.successRate}</span>
                    </div>
                    <div className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full">
                      <span className="text-xs font-semibold text-gray-900">{treatment.category}</span>
                    </div>
                  </div>
                  <div className="p-4 flex flex-col flex-1">
                    <div className="mb-3 h-16">
                      <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight">{treatment.name}</h3>
                    </div>
                    <div className="mb-3 h-20">
                      <p className="text-gray-600 text-xs leading-relaxed line-clamp-4">{treatment.description}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-3 h-20">
                      <div className="p-2 bg-gray-50 rounded-lg text-center flex flex-col justify-center">
                        <Clock className="w-4 h-4 text-teal-600 mx-auto mb-1" />
                        <p className="text-xs text-gray-500">Duration</p>
                        <p className="text-xs font-bold text-gray-900">{treatment.duration}</p>
                      </div>
                      <div className="p-2 bg-gray-50 rounded-lg text-center flex flex-col justify-center">
                        <Calendar className="w-4 h-4 text-teal-600 mx-auto mb-1" />
                        <p className="text-xs text-gray-500">Recovery</p>
                        <p className="text-xs font-bold text-gray-900">{treatment.recovery}</p>
                      </div>
                    </div>
                    <div className="mt-auto">
                      <button className="w-full bg-gradient-to-r from-teal-600 to-teal-700 text-white py-2 rounded-lg hover:from-teal-700 hover:to-teal-800 transition-all duration-300 flex items-center justify-center space-x-2 text-sm font-semibold h-10">
                        <span>Get Details</span>
                        <ArrowRight className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .line-clamp-4 {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default HospitalTreatmentsShowcase;